import WhiteHead from './WhiteHead'
import WhiteTab from './WhiteTab'
import { lazy, Suspense } from 'react'

const WhiteMobilize = lazy(() => import("./WhiteMobilize"));
const WhitePlatform = lazy(() => import("./WhitePlatform"));
const WhiteSolution = lazy(() => import("./WhiteSolution"));
const WhiteDemo = lazy(() => import("./WhiteDemo"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const whiteLabelFeatureId = "white-label-solution";
export default function WhiteLabel() {
  return (
    <>
      <WhiteHead featureId={whiteLabelFeatureId} />
      <WhiteTab />

      <Suspense fallback={null}>
        <WhiteMobilize />
        <WhitePlatform />
        <WhiteSolution />
        <WhiteDemo />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed
          featureId={whiteLabelFeatureId}
        />
      </Suspense>
    </>
  )
}
